import React from 'react'
import Chip from '@mui/material/Chip'
import { ServiceStatusKind } from '../utils/serviceStatus'

interface ServiceStatusChipProps {
  label: string
  kind: ServiceStatusKind
}

export function ServiceStatusChip({ label, kind }: ServiceStatusChipProps) {
  const canceled = kind === 'canceled'

  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      sx={{
        flexShrink: 0,
        backgroundColor: canceled ? '#FDECEA' : '#EAF5EB',
        borderColor: canceled ? '#F1BDBA' : '#B4DDB6',
        color: (theme) =>
          canceled ? theme.palette.error.dark : theme.palette.success.main,
      }}
    />
  )
}

ServiceStatusChip.displayName = 'ServiceStatusChip'
